export default "__VITE_ASSET__d26407c2__"